import { Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
    selector   : 'my-button',
    template: '<div class="button {{button.style}}" [class.test]="button.disabledAction==3" (click)="click()"><i class="fa {{button.icon}}" aria-hidden="true"></i><span>{{button.title}}</span></div>',
    styles: [require('./button.component.scss')],
    encapsulation: ViewEncapsulation.None,
})

export class ButtonComponent {

    @Input() button: any;
    @Input('model') model:any;

    constructor() {

    }

    click(){
        this.button.model[this.button.action]();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/button/button.component.ts